module.exports = __webpack_public_path__ + "assets/img/culture-item-one.2c48d758.png";